module.exports = __webpack_public_path__ + "static/media/cases_logos_eventos_03.6d27bd8f.jpg";